import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavigationBar } from "../../Navigation/Navigation";
function PageWrap({ children, loading = false, onRefresh, className }) {
    return (_jsxs("div", { className: "wpqt-flex wpqt-flex-col", children: [_jsx("div", { className: `wpqt-user-app-content-height wpqt-order-1 wpqt-overflow-y-auto lg:wpqt-order-2 ${className}`, children: children }), _jsx("div", { className: "wpqt-order-2 lg:wpqt-order-1", children: _jsx(NavigationBar, { loading: loading, onRefresh: onRefresh }) })] }));
}
function PageContentWrap({ children }) {
    return _jsx("div", { className: "wpqt-p-4", children: children });
}
function PageScreenMiddle({ children }) {
    return (_jsx("div", { className: "wpqt-flex wpqt-h-screen wpqt-flex-col wpqt-items-center wpqt-justify-center", children: children }));
}
function PageTitle({ children, description, titleClassName = "", className = "", }) {
    return (_jsxs("div", { className: `wpqt-mb-6 ${className}`, children: [_jsx("h1", { className: `wpqt-m-0 wpqt-text-center wpqt-text-2xl wpqt-font-normal ${titleClassName}`, children: children }), description && (_jsx("div", { className: "wpqt-mt-1 wpqt-text-center wpqt-text-gray-600", children: description }))] }));
}
export { PageContentWrap, PageScreenMiddle, PageTitle, PageWrap };
